import { useMemo } from 'react';
import { useGetVenteQuery } from 'actions/ventes/queries';
import { useGetClientQuery } from 'actions/clients/queries';
import { useUpdateVenteMutation } from 'actions/ventes/mutations';
import { toast } from 'react-toastify';
import { extractListData, formatQueryError } from 'utils/queryHelpers';

const useVentesData = (dossierId) => {
  const { data: venteResponse, error: venteError, isLoading: isLoadingVentes, isFetching: isFetchingVentes, refetch } = useGetVenteQuery({
    dossier_id: dossierId
  });
  const { data: clientResponse, error: clientError, isLoading: isLoadingClients } =
    useGetClientQuery({ dossier_id: dossierId });

  const [updateVente] = useUpdateVenteMutation();

  const updatedVentes = useMemo(() => {
    const ventesData = extractListData(venteResponse, venteError, isLoadingVentes);
    const clientData = extractListData(clientResponse, clientError, isLoadingClients);

    if (!ventesData || ventesData.length === 0) return [];

    const clientMap = clientData.reduce((acc, client) => {
      acc[client.id] = client.nom;
      return acc;
    }, {});

    return ventesData.map((vente) => ({
      ...vente,
      clientNom: (vente.client_details?.nom) || clientMap[vente.clientId] || clientMap[vente.client] || 'N/A',
    }));
  }, [venteResponse, clientResponse, venteError, clientError, isLoadingVentes, isLoadingClients]);

  const queryError = venteError ? formatQueryError(venteError) : (clientError ? formatQueryError(clientError) : null);

  const handleUpdateVente = async (venteId, updateData) => {
    try {
      await updateVente({ id: venteId, ...updateData }).unwrap();
      await refetch();
    } catch (error) {
      toast.error(
        `Erreur lors de la mise à jour: ${error.data?.error || error.message}`
      );
      console.error(error);
    }
  };

  return {
    updatedVentes,
    handleUpdateVente,
    refetch,
    error: queryError,
    isLoading: isLoadingVentes || (isFetchingVentes && (!venteResponse || extractListData(venteResponse).length === 0)),
  };
};

export default useVentesData;

